var exports = {
  "kL": "xa9f3555f--ee4b21--container",
  "Qs": "xa9f3555f--ee4b21--content",
  "Sl": "xa9f3555f--ee4b21--image",
};

module.exports = exports;
